export default {
    companyProfile: {},
    session: {},
    edition: {},
    bootLoaded: false,
};
